import * as React from 'react';
import { compose, withState, withPropsOnChange, withHandlers } from 'recompose';

export type RepeatedGifProps = {
  className?: string;
  src: string;
  repeatedWhen: boolean;
};

type InnerProps = {
  srcInternal: string;
  setSrcInternal: (_: string | undefined) => void;
  repeatGif: () => void;
} & RepeatedGifProps;

const RepeatedGif: React.SFC<InnerProps> = props => {
  return <img
    className={props.className}
    src={props.srcInternal} />
};

export default compose<RepeatedGifProps, RepeatedGifProps>(
  withState('srcInternal', 'setSrcInternal', undefined),
  withHandlers<InnerProps, {}>({
    repeatGif: (_: InnerProps) => () => {
      if (!!_.repeatedWhen) {
        _.setSrcInternal(undefined);
        setTimeout(() => {
          _.setSrcInternal(_.src);
        }, 0);
      }
    }
  }),
  withPropsOnChange<any, InnerProps>(['repeatedWhen'], _ => {
    _.repeatGif();
  })
)(RepeatedGif);


// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/RepeatedGif.tsx